const APP_SET_LOCALE = 'APP_SET_LOCALE';

export default {
  APP_SET_LOCALE,
};